import { render, staticRenderFns } from "./ListingApplicants.vue?vue&type=template&id=6b183ef1&scoped=true&"
import script from "./ListingApplicants.vue?vue&type=script&lang=ts&"
export * from "./ListingApplicants.vue?vue&type=script&lang=ts&"
import style0 from "./ListingApplicants.vue?vue&type=style&index=0&id=6b183ef1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b183ef1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VImg,VLayout,VTooltip})
